<div fxLayout="row" fxLayoutAlign="start center">
  <h2 fxFlex>Signatures</h2>
  <button mat-icon-button (click)="signatureList.refreshSignatures.next()">
    <mat-icon>refresh</mat-icon>
  </button>
</div>
<app-signature-list
  #signatureList
  [signable]="signable$ | async"
></app-signature-list>

<div
  class="flex md:flex-row md:gap-x-2 md:gap-y-0 gap-y-2 justify-start md:items-center flex-col items-start"
>
  <ng-container *ngIf="signaturesOnScreen | async; else signatureDeviceButtons">
    <button mat-raised-button (click)="openSignatureDialog()">
      <mat-icon>add</mat-icon>
      Open Signature Pad
    </button>
    <button mat-raised-button (click)="requestSignature()">
      <mat-icon>add</mat-icon>
      Capture on Mobile Device
    </button>
  </ng-container>
  <ng-template #signatureDeviceButtons>
    <button mat-raised-button (click)="requestSignature()">
      <mat-icon>add</mat-icon>
      Request Signature
    </button>
    <button mat-flat-button (click)="openSignatureDialog()">
      <mat-icon>add</mat-icon>
      Open Signature Pad
    </button>
    <button mat-flat-button (click)="signatureList.refreshSignatures.next()">
      Refresh list
    </button>
    <button mat-flat-button label="help" (click)="openDeviceSetup()">
      Help
    </button>
  </ng-template>
</div>
